/**
 * 服務條款內容組件
 * 顯示 Mayi AI 的服務條款內容
 */
import { LegalSection, LegalParagraph } from "./index";

export function TermsContent() {
  return (
    <div className="text-gray-700">
      <LegalSection title="1. 服務說明">
        <LegalParagraph>
          <strong className="font-semibold text-[#6B8E5A]">
            1.1 服務概述：
          </strong>{" "}
          <strong>麻薏 Mayi AI</strong> 是一個 AI
          輔助網站建置平台，透過人工智慧技術協助使用者快速建立、設計和發布個人或商業網站。
        </LegalParagraph>

        <LegalParagraph>
          <strong className="font-semibold text-[#6B8E5A]">
            1.2 服務範圍：
          </strong>{" "}
          本服務包括但不限於：AI 輔助網站設計、內容生成、網站發布、網域設定、SEO
          優化建議等功能。
        </LegalParagraph>

        <LegalParagraph>
          <strong className="font-semibold text-[#6B8E5A]">
            1.3 服務變更：
          </strong>{" "}
          我們保留隨時修改、暫停或終止本服務任何部分的權利，並會盡可能提前通知使用者。
        </LegalParagraph>
      </LegalSection>

      <LegalSection title="2. 使用者資格與帳戶">
        <LegalParagraph>
          <strong className="font-semibold text-[#6B8E5A]">
            2.1 使用資格：
          </strong>{" "}
          您必須年滿 16 歲才能使用本服務。若您未滿 18
          歲，應在法定監護人的同意和監督下使用本服務。
        </LegalParagraph>

        <LegalParagraph>
          <strong className="font-semibold text-[#6B8E5A]">
            2.2 帳戶註冊：
          </strong>{" "}
          使用本服務可能需要創建帳戶。您同意提供準確、完整且最新的資訊，並對帳戶的所有活動負責。
        </LegalParagraph>

        <LegalParagraph>
          <strong className="font-semibold text-[#6B8E5A]">
            2.3 帳戶安全：
          </strong>{" "}
          您有責任維護帳戶密碼的機密性，並限制對您電腦和帳戶的訪問。您同意對在您帳戶下發生的所有活動負責。
        </LegalParagraph>

        <LegalParagraph>
          <strong className="font-semibold text-[#6B8E5A]">
            2.4 第三方登入：
          </strong>{" "}
          我們提供透過第三方服務（如
          Google）登入的選項。使用這些服務登入時，您同意遵守這些第三方服務的條款和隱私政策。
        </LegalParagraph>
      </LegalSection>

      <LegalSection title="3. 使用者行為與責任">
        <LegalParagraph>
          <strong className="font-semibold text-[#6B8E5A]">
            3.1 禁止行為：
          </strong>{" "}
          使用本服務時，您同意不會：
        </LegalParagraph>

        <LegalParagraph>
          上傳、發布或傳輸任何非法、有害、威脅、辱罵、騷擾、誹謗、淫穢或其他不適當的內容
        </LegalParagraph>

        <LegalParagraph>
          侵犯他人的智慧財產權、隱私權或其他合法權利
        </LegalParagraph>

        <LegalParagraph>
          使用本服務從事任何非法活動或違反任何適用法律
        </LegalParagraph>

        <LegalParagraph>試圖未經授權訪問本服務的系統或網絡</LegalParagraph>

        <LegalParagraph>
          使用自動化程序（如爬蟲、機器人）訪問或使用本服務，除非我們明確許可
        </LegalParagraph>

        <LegalParagraph>
          <strong className="font-semibold text-[#6B8E5A]">
            3.2 內容與智慧財產權：
          </strong>
        </LegalParagraph>

        <LegalParagraph>
          (a){" "}
          <strong className="font-semibold text-[#6B8E5A]">
            使用者提供內容：
          </strong>{" "}
          您保留您上傳或提供給本服務的內容（如文字、圖像、標誌等）的所有權利。您授予我們全球性、非專屬、免版稅的許可，允許我們使用、複製、修改、發布和處理這些內容，以提供和改進本服務。
        </LegalParagraph>

        <LegalParagraph>
          (b){" "}
          <strong className="font-semibold text-[#6B8E5A]">
            AI 輔助產出：
          </strong>{" "}
          透過本服務 AI
          功能生成的內容（如文字建議、設計元素等），我們授予您有限的、非專屬的使用權，僅限於您的網站和相關推廣材料。您不得將這些
          AI 產出單獨銷售、分發或用於其他商業目的。
        </LegalParagraph>

        <LegalParagraph>
          (c){" "}
          <strong className="font-semibold text-[#6B8E5A]">網站成品：</strong>{" "}
          您透過本服務創建的最終網站，包括整合了您自己內容和 AI
          輔助產出的完整網站，歸您所有。您可以按照您的意願使用、修改或分發這些網站，前提是不違反本條款中關於
          AI 輔-助產出的限制。
        </LegalParagraph>
      </LegalSection>

      <LegalSection title="4. 智慧財產權">
        <LegalParagraph>
          <strong className="font-semibold text-[#6B8E5A]">
            4.1. 麻薏 Mayi AI 智慧財產權：
          </strong>{" "}
          本服務本身，包括其所有技術、軟體、設計、AI
          模型、Logo、商標等智慧財產權，均歸麻薏 Mayi AI
          團隊或其授權人所有。未經我們書面同意，您不得複製、修改、散布或創作衍生作品。
        </LegalParagraph>

        <LegalParagraph>
          <strong className="font-semibold text-[#6B8E5A]">
            4.2. 使用者提供內容之智慧財產權：
          </strong>{" "}
          如第 3.2(a) 條所述，您擁有您所提供內容的智慧財產權。
        </LegalParagraph>

        <LegalParagraph>
          <strong className="font-semibold text-[#6B8E5A]">
            4.3. AI 輔助產出及網站成品之使用權利：
          </strong>{" "}
          如第 3.2(b) 及 3.2(c) 條所述，我們授予您對 AI
          輔助產出及最終網站成品的有限使用授權，並明確其限制範圍。
        </LegalParagraph>
      </LegalSection>

      <LegalSection title="5. MVP 階段與未來變更">
        <LegalParagraph>
          <strong className="font-semibold text-[#6B8E5A]">免費使用：</strong>{" "}
          您理解並同意，本服務目前處於 MVP
          階段，主要功能免費提供，目的是收集使用者回饋與推廣。
        </LegalParagraph>
        <LegalParagraph>
          <strong className="font-semibold text-[#6B8E5A]">
            保留收費權利：
          </strong>{" "}
          我們保留未來可能針對部分進階功能、服務方案或超出免費額度的使用量收取費用的權利。若推出收費項目，我們會提前給予您充分通知，並說明收費標準與方式，您可以自行決定是否付費升級或繼續使用免費功能（若適用）。
        </LegalParagraph>
      </LegalSection>

      <LegalSection title="6. 聯絡我們">
        <LegalParagraph>
          若您對本服務條款有任何疑問，歡迎透過以下方式與我們聯繫：
        </LegalParagraph>
        <LegalParagraph>
          Email:{" "}
          <a
            href="mailto:support@mayiai.co"
            className="font-medium text-[#6B8E5A] hover:text-[#9BBF85] transition-colors duration-300"
          >
            support@mayiai.co
          </a>
        </LegalParagraph>
      </LegalSection>
    </div>
  );
}
